import { render, staticRenderFns } from "./GoodsCardForDataPro.vue?vue&type=template&id=78ebd4cc&scoped=true&"
import script from "./GoodsCardForDataPro.vue?vue&type=script&lang=js&"
export * from "./GoodsCardForDataPro.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCardForDataPro.vue?vue&type=style&index=0&id=78ebd4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ebd4cc",
  null
  
)

export default component.exports